import React from 'react';

function Footer(props){
  return(
    <div className="border-top border-info pt-3 text-center">
      <small>Cards React App Project © {new Date().getFullYear()} - 2021</small>
      
      <p>Svetlana</p> 
      
    </div>
  )
}

export default Footer